define('responsive',['jquery'], function() {

  var deviceSize;
  var t1;
  var t2;
  var waitTime = 0;

  var getMq = function(){
    var mq = null;
    mq = window.getComputedStyle(document.documentElement, null).getPropertyValue('font-family');

    if (mq === null) {
      return 'lg';
    }
    mq = mq.replace(/['",]/g, '');

    if (mq !== 'sm' || mq !== 'md' || mq !== 'lg') {
      var newMq;
      // IE 9
      if (document.documentElement.currentStyle) {
        newMq = document.documentElement.currentStyle['animation-name'];
      }
      // if we don't check for undefined, IE 9 would return '', so we avoid that
      if (window.getComputedStyle && typeof newMq === 'undefined') {
        newMq = window.getComputedStyle(document.documentElement, null).getPropertyValue('animation-name');
      }
      newMq = newMq.replace(/['",]/g, '');
      mq = newMq;
      // console.log('Breakpoint: font-family was overwritten, using animation-name instead: ' + mq);
    }
    return mq;
  };

  var v_breakPoint = getMq();
  window.BREAKPOINT = v_breakPoint;
  var initalBreakpoint = true;

  var init = function() {
    $('body').removeClass();
    $('body').addClass(deviceSize);
    window.BREAKPOINT = deviceSize;
    $(window).trigger('breakpoint');
    if ( initalBreakpoint ){
      $(window).trigger('initialBreakpoint');
    }
    initalBreakpoint = false;
  };

  window.initResponsive = function(){
    t2 = setTimeout(function(){
      deviceSize = getMq();
      init();
      clearTimeout(t2);
    }, waitTime);
  };

  $(function() {
    $(window).resize(function(){
      if (t1) { clearTimeout(t1); }
      t1 = setTimeout(function(){
        var checkSize = getMq();
        if (checkSize !== deviceSize) {
          deviceSize = checkSize;
          init();
        }
      }, 0);
    });
  });

  $(window).on('loaded', function(){
    window.initResponsive();
  });

  return function responsive(){
    var bk = window.BREAKPOINT;
    if ('none' === bk) {
      bk = getMq();
    }
    return bk;
  }

});

